const ATTEMPT = 'ATTEMPT'
const SUCCESS = 'SUCCESS'
const ERROR = 'ERROR'
const SYSTEM = 'SYSTEM'

const constantStates = [ATTEMPT, SUCCESS, ERROR, SYSTEM]

export default (constantsSet) => {
  const newConstantsSet = {}
  Object.keys(constantsSet).forEach((constantName) => {
    const constantValue = constantsSet[constantName]
    constantStates.forEach((constantState) => {
      newConstantsSet[constantName] = { ...newConstantsSet[constantName] }
      newConstantsSet[constantName][constantState] = `${constantValue}/${constantState}`
    })
  })

  return newConstantsSet
}
